/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_CaptainInputs */

const es_footer_link_captain = /** @type {(inputs: Footer_Link_CaptainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Eres capitán o patrón?`)
};

const gl_footer_link_captain = /** @type {(inputs: Footer_Link_CaptainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es capitán ou patrón?`)
};

const en_footer_link_captain = /** @type {(inputs: Footer_Link_CaptainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you a skipper or captain?`)
};

/**
* | output |
* | --- |
* | "Are you a skipper or captain?" |
*
* @param {Footer_Link_CaptainInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_link_captain = /** @type {((inputs?: Footer_Link_CaptainInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_CaptainInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_footer_link_captain(inputs)
	if (locale === "en") return en_footer_link_captain(inputs)
	return es_footer_link_captain(inputs)
});